import {Constructor} from "../../global/constructor";

export let TypeHelper = {
  isInstanceOf<T>(x, aClass: Constructor<T> | string): x is T {
      return typeof x === aClass
  }
};
